import { render } from "./invoice-batch-created-notification-modal.vue?vue&type=template&id=6acb713c&ts=true"
import script from "./invoice-batch-created-notification-modal.ts?vue&type=script&lang=ts&external"
export * from "./invoice-batch-created-notification-modal.ts?vue&type=script&lang=ts&external"

import "./invoice-batch-created-notification-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__